import { render, staticRenderFns } from "./FloatingWindow.vue?vue&type=template&id=15ccc45f"
import script from "./FloatingWindow.vue?vue&type=script&lang=js"
export * from "./FloatingWindow.vue?vue&type=script&lang=js"
import style0 from "./FloatingWindow.vue?vue&type=style&index=0&id=15ccc45f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports